import { render, staticRenderFns } from "./EntryMessageHistoryStatus.vue?vue&type=template&id=62791d6c"
import script from "./EntryMessageHistoryStatus.vue?vue&type=script&lang=js"
export * from "./EntryMessageHistoryStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports